import React, { Component } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import Preloader from "../../views/Preloader/Preloader";

import CheckData from '../../shared/CheckData';

import Calificaciones from './Calificaciones';

let statusUser = 0;
class MainAcademicosProf extends Component {
    state = {
        statusUser: 0,
    }

    constructor (props) {
        super (props);
        CheckData((resp) => {
            statusUser = parseInt(resp)
            this.setState ({
                statusUser: parseInt(resp)
            })
        });
    }

    contenido = () => {
        return (
            <Switch>
                <Route path="/prof_academicos/calificaciones" component={ () => <Calificaciones/> } />
                <Redirect to = "/prof_academicos/calificaciones" />
            </Switch>
        )
    }

    render() {
        switch (statusUser) {
            case 0:
                return(<Preloader/>) 
            case 1:
                return (<Redirect to="/perfil" />)
            case 2:
                return (<Redirect to="/perfil" />)
            case 3:
                return (this.contenido())
            case 4:
                return (<Redirect to="/perfil" />)
            default:
                return(<Preloader/>) 
        }
    }
}
 
export default MainAcademicosProf;


// WEBPACK FOOTER //
// ./src/views/ProfAcademicos/MainAcademicosProf.jsx